module.exports = __webpack_public_path__ + "static/media/house6.3233721f.png";